import React from "react";
import { BsExclamationCircle } from "react-icons/bs";
import "./ResponsesCount.css";

// Results > By User table heading: "Responses [X] · Y need attention". `attentionCount` is
// null where the Trivvy has no Needs Attention column (KCs, no open-text questions).
const ResponsesCount = ({ count, attentionCount }) => {
  const showAttention = typeof attentionCount === "number" && attentionCount > 0;
  return (
    <div className="responses-count">
      <span className="responses-count-label">Responses</span>
      <span className="responses-count-badge">{count}</span>
      {showAttention && (
        <>
          <span className="responses-count-sep" aria-hidden="true">·</span>
          <span className="responses-count-attention">
            <BsExclamationCircle className="responses-count-attention-icon" aria-hidden="true" />
            {attentionCount} need{attentionCount === 1 ? "s" : ""} attention
          </span>
        </>
      )}
    </div>
  );
};

export default ResponsesCount;
